import { SelectOption } from "./select-option";

export class MultiSelectOption extends SelectOption {

    selected: boolean;

    constructor(value: string | Array<string> | number, label: string, selected: boolean) {
        super(value, label);

        this.selected = selected;
    }

    getSelected(): boolean {
        return this.selected;
    }
}



// WEBPACK FOOTER //
// ./src/core/interfaces/multi-select-option.ts